import { messages } from "../engine/messageCatalogue";
import { SkippedRow } from "../engine/validationTypes";
import type { AnnotatedIssue } from "./annotatedFile";

export function buildLeftOutIssues(skippedRows: SkippedRow[]): AnnotatedIssue[] {
  return skippedRows.map((row) => ({
    worksheet: row.worksheet,
    rowNumber: row.rowNumber,
    message: messages.leftOutRow(row),
  }));
}
